import React from 'react';
import { useIntl } from 'react-intl';

import PropTypes from 'prop-types';

import ExtraActionsComponent from '@/components/ExtraActions/ExtraActionsComponent';
import { orderType as parseOrderType } from '@/constants';

const ExtraActionsContainer = ({ changePage, orderData, orderType, clientPanel, orderId }) => {
  const intl = useIntl();

  const features = JSON.parse(window.sessionStorage.getItem('me')).features.map(feature => parseOrderType.get(feature));

  const orderTypeConfigurations = JSON.parse(window.sessionStorage.getItem('orderTypeConfigurations'));

  const shouldShowButton = feature =>
    orderTypeConfigurations &&
    orderTypeConfigurations[orderType] &&
    orderTypeConfigurations[orderType][orderData.status] &&
    orderTypeConfigurations[orderType][orderData.status].extraActions &&
    orderTypeConfigurations[orderType][orderData.status].extraActions.indexOf(feature) > -1 &&
    features.indexOf(feature) > -1;

  return (
    <ExtraActionsComponent
      changePage={changePage}
      clientPanel={clientPanel}
      orderId={orderId}
      intl={intl}
      orderData={orderData}
      shouldShowButton={shouldShowButton}
    />
  );
};

ExtraActionsContainer.propTypes = {
  changePage: PropTypes.func.isRequired,
  orderData: PropTypes.object,
  orderType: PropTypes.string.isRequired,
  clientPanel: PropTypes.bool,
  orderId: PropTypes.string,
};

ExtraActionsContainer.defaultProps = {
  orderData: null,
  clientPanel: false,
  orderId: null,
};

export default ExtraActionsContainer;
